(function () {
    'use strict';

    angular
        .module('app')
        .factory('TasksService', TasksService);

    TasksService.$inject = [
        '$http',
        'DataService',
        'UrlService'];

    function TasksService(
        $http,
        DataService,
        UrlService) {
        var resourceUrl = 'task';
        var service = {};

        angular.extend(service, DataService(resourceUrl));

        angular.extend(service, {
            query: query,
            save: save,
            completeTasks: completeTasks,
            multiDelete: multiDelete,
            multiCopy: multiCopy,
            count: count
        });

        return service;
        
        function query(queryParams) {
            var pars = angular.copy(queryParams);
            var searchFields = pars.searchFields;
            delete pars.searchFields;

            var queryString = service.convertQueryParams(pars);

            if (!angular.isUndefined(queryParams.searchFields) && queryParams.searchFields !== null) {
                angular.forEach(Object.keys(queryParams.searchFields), function (searchFieldKey) {
                    queryString += queryString.length > 0 ? '&' : '?';
                    queryString += searchFieldKey + '=' + queryParams.searchFields[searchFieldKey];
                });
            }

            return DataService(resourceUrl).query(queryString);
        }

        /**
         * POST a new task, or PUT to update an existing one.
         * The clients current time offset will be appended onto the task data before sending the request.
         *
         * If the task provided has a non-zero id or Id property, an existing task will be updated.
         * Otherwise, a new task will be created.
         *
         * @param {Object} - The task to save.
         */
        function save(task) {
            if (task.Id || task.id) {
                var id = task.Id ? task.Id : task.id;
                return $http.put(UrlService.getWebAPIUrl() + '/task/' + id, task)
                    .then(function (response) {
                        return response.data;
                    });
            } else {
                return $http.post(UrlService.getWebAPIUrl() + '/task/', task)
                    .then(function (response) {
                        return response.data;
                    });
            }
        }

        /**
         * Complete/uncomplete the specified tasks
         *
         * @param {bool} complete - If true the tasks were be completed, otherwise they will be uncompleted
         * @param {array} taskIds - List of task ids which are to be completed/uncompleted
         * @param {string} note - Note which is to be stored on the tasks.
         */
        function completeTasks(complete, taskIds, note) {
            var requestUrl = UrlService.getWebAPIUrl() + '/taskcomplete';

            return $http.post(requestUrl, {Complete: complete, TaskIds: taskIds, Note: note});
        }

        /**
         * Deletes the specified tasks
         *
         * @param {array} taskIds - An array of task ids for the tasks to be deleted.
         * @return {promise} A promise resolved once the task deletion is complete, rejects with a http response if there was a server-side error.
         */
        function multiDelete(taskIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/taskdelete', taskIds);
        }

        /**
         * Create copies of the specified tasks.
         *
         * @param {array} taskIds - An array of task ids for the tasks to be copied.
         * @return {promise} A promise resolved once the task copy is complete, rejects with a http response if there was a server-side error.
         */
        function multiCopy(taskIds) {
            return $http.post(UrlService.getWebAPIUrl() + '/taskcopy', { TaskIds: taskIds });
        }

        /**
         * Gets the count of tasks
         *
         * @param {bool} completed
         * @param {bool} deleted
         * @returns {promise} A promise that resolves with the count
         */
        function count(completed, deleted) {
            var url = UrlService.getWebAPIUrl() + '/task/count';
            var params = '';

            if (!_.isNil(completed)) {
                params += '?completed=' + completed;
            }

            if (!_.isNil(deleted)) {
                params += params === '' ? '?' : '&';
                params += 'deleted=' + deleted;
            }

            return $http.get(url + params).then(
                function (response) {
                    return response.data;
                });
        }
    }
})();